import { render, staticRenderFns } from "./wxDialogComponent.vue?vue&type=template&id=63fc4b7c"
import script from "./wxDialogComponent.vue?vue&type=script&lang=js"
export * from "./wxDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./wxDialogComponent.vue?vue&type=style&index=0&id=63fc4b7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports